import { createAction, props } from '@ngrx/store';

import { ConsigneeCustomerLookupResponseBody, ConsigneeLookupResponseBody } from '#types/consignee';
import { Filters, Sorts } from '#types/grid';

//
// consignee / lookup dialog
//

export const ConsigneeLookupDialogRequestData = createAction('[Consignee.Lookup.Dialog] - Grid Request Data', props<{ id: string }>());
export const ConsigneeLookupDialogRequestDataWithParameters = createAction(
  '[Consignee.Lookup.Dialog] - Grid Request Data With Parameters',
  props<{ id: string; filters: Filters; page: number; first: number; rows: number; sorts: Sorts }>()
);
export const ConsigneeLookupDialogRequestDataWithFilters = createAction(
  '[Consignee.Lookup.Dialog] - Grid Request Data With Filters',
  props<{ id: string; filters: Filters }>()
);
export const ConsigneeLookupDialogRequestDataSuccess = createAction(
  '[Consignee.Lookup.Dialog] - Grid Request Data Success',
  props<{ id: string; data: ConsigneeLookupResponseBody }>()
);
export const ConsigneeLookupDialogRequestDataFailure = createAction(
  '[Consignee.Lookup.Dialog] - Grid Request Data Failure',
  props<{ id: string }>()
);

//
// consignee / customer consignee lookup dialog
//

export const CustomerConsigneeLookupDialogRequestData = createAction(
  '[Consignee.Customer.Lookup.Dialog] - Grid Request Data',
  props<{ id: string }>()
);
export const CustomerConsigneeLookupDialogRequestDataWithParameters = createAction(
  '[Consignee.Customer.Lookup.Dialog] - Grid Request Data With Parameters',
  props<{ id: string; filters: Filters; page: number; first: number; rows: number; sorts: Sorts }>()
);
export const CustomerConsigneeLookupDialogRequestDataWithFilters = createAction(
  '[Consignee.Customer.Lookup.Dialog] - Grid Request Data With Filters',
  props<{ id: string; filters: Filters }>()
);
export const CustomerConsigneeLookupDialogRequestDataSuccess = createAction(
  '[Consignee.Customer.Lookup.Dialog] - Grid Request Data Success',
  props<{ id: string; data: ConsigneeCustomerLookupResponseBody }>()
);
export const CustomerConsigneeLookupDialogRequestDataFailure = createAction(
  '[Consignee.Customer.Lookup.Dialog] - Grid Request Data Failure',
  props<{ id: string }>()
);
